import { SHFilterOption } from "@components/design-systems";
import { PortfolioCompositionViewMode } from "@models/platform-analysis/enums/portfolioCompositionViewMode";
import { ProductRecommendationTypes } from "@models/platform-analysis/enums/summary/recommendationType";
import { TableViewMode } from "@models/platform-analysis/enums/tableViewMode";
import { toSentence } from "@utils";

export class AnalysisSummaryPortfolioDetailsMessages {
  static readonly RetailInsurancePoliciesRegex =
    /Retail insurance policies in (IDPS|Super): .*/g;
  static readonly CashInIdps = "Cash in IDPS accounts";
  static readonly CashInSuperPension = "Cash in Super/Pension accounts";
  static readonly ManagedFunds = "Managed funds";
  static readonly ManagedAccounts = "Managed accounts (SMA or MDA models)";
  static readonly AustralianListedInvestments = "Australian listed investments";
  static readonly InternationalListedInvestments =
    "International listed investments";
  static readonly UnlistedBonds = "Unlisted bonds";
  static readonly TermDeposits = "Term deposits";
  static readonly RetailInsurance = "Retail insurance";
  static readonly RetailInsurancePoliciesInIDPS =
    "Retail insurance policies in IDPS";
  static readonly RetailInsurancePoliciesInSuper =
    "Retail insurance policies in Super";
  static readonly CfsEdgeFullMenu = "CFS Edge Full menu";
  static readonly CfsEdgeAccelerate100SMAs = "CFS Edge Accelerate 100 SMAs";
  static readonly CfsEdgeAccelerate30SMAs = "CFS Edge Accelerate 30 SMAs";
  static readonly CfsEdgeManagedFundsEligibleForNoAdminFees =
    "CFS Edge managed funds eligible for no admin fees";
  static readonly ExpandEssential = "Expand Essential";
  static readonly ExpandEssentialPlus = "Expand Essential+";
  static readonly NorthChoice = "North Choice";
  static readonly NorthSelect = "North Select";
  static readonly NorthGrow = "North Grow";
  static readonly TotalPortfolioValue = "Total portfolio value";
  static readonly InvestmentsAndOtherHoldings =
    "Investments and other holdings";
  static readonly TotalDifferentInvestmentsHeld =
    "Total number of different investments held";
  static readonly NumberOfRetailInsurancePolices =
    "Number of retail insurance polices";
  static readonly BalanceInCFSEdgeMenus = "Balance in CFS Edge menus";
  static readonly BalanceInExpandEssentialMenus =
    "Balance in Expand Essential menus";
  static readonly BalanceInNorthMenus = "Balance in North menus";
  static readonly ManageAccountTransactionOutside =
    "Transactions outside managed accounts (Next 12 months)";
  static readonly ManageAccountTransactionOutsideHtml = (
    <>
      Transactions <u>outside</u> managed accounts (Next 12 months)
    </>
  );
  static readonly ManageAccountTransactionWithin =
    "Transactions within managed accounts (Next 12 months)";
  static readonly ManageAccountTransactionWithinHtml = (
    <>
      Transactions <u>within</u> managed accounts (Next 12 months)
    </>
  );
}

export const CurrentProductRecommendationStatusOptions: SHFilterOption[] = [
  ProductRecommendationTypes.Retain,
  ProductRecommendationTypes.Replace,
  ProductRecommendationTypes.Custom,
].map((i) => ({
  value: i,
  label: toSentence(i),
}));

export const OtherProductRecommendationStatusOptions: SHFilterOption[] = [
  ProductRecommendationTypes.Recommended,
  ProductRecommendationTypes.NotRecommended,
  ProductRecommendationTypes.Alternative,
  ProductRecommendationTypes.Custom,
].map((i) => ({
  value: i,
  label: toSentence(i),
}));

export const FeatureAnalysisTableViewModeOptions = [
  {
    value: TableViewMode.Detail,
    label: "Detail",
  },
  {
    value: TableViewMode.Default,
    label: "Sub-groups",
  },
  {
    value: TableViewMode.Summary,
    label: "Groups",
  },
];

export const PortfolioCompositionTableViewModeOptions = [
  { label: "", value: PortfolioCompositionViewMode.Included },
  { label: "", value: PortfolioCompositionViewMode.Excluded },
];
